import { Validations } from "@experta/commons-v2.layout";
import * as lang from "./lang.json";

/**
 * Interface used as props.
 * @name NonRepetitionClauseFormProps
 */
export interface NonRepetitionClauseFormProps {
    onChange?: (data: any) => void;
}

/**
 * Interface used as non repetition clause form.
 * @name NonRepetitionClause
 */
export interface NonRepetitionClause {
    cuit: string,
    businessName: string,
    errorsMessages: Array<{ field: string, message: string }>
}
/**
 * Interface used as non repetition clause form.
 * @name NonRepetitionClauseForm
 */
export interface NonRepetitionClauseForm extends Array<NonRepetitionClause> { }

export const validateForm = (currentForm: NonRepetitionClauseForm): NonRepetitionClauseForm => {

    currentForm.forEach((item: NonRepetitionClause) => {
        item.errorsMessages = [];
        if (!(Validations.required(item.businessName))) {
            item.errorsMessages.push({ field: "businessName", message: lang.errors.required });
        }
        else if (!(Validations.alphaNumeric(item.businessName as string, true) && Validations.maxLength(item.businessName as string, 60))) {
            item.errorsMessages.push({ field: "businessName", message: lang.errors.invalid });
        }
        if (!Validations.cuil(item.cuit)) {
            item.errorsMessages.push({ field: "cuit", message: lang.errors.invalid });
        }
    });

    return currentForm;
}